import React from 'react';
import PropTypes from 'prop-types';

import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';
import CartItemPhotoPreview from './CartItemPhotoPreview';
import TrashIcon from '../../../../components/icons/TrashIcon';
import SaveIcon from '../../../../components/icons/SaveIcon';
import CartItemVendor from './CartItemVendor';
import Badge from '../../../../components/global/Badge';

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
          size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)).isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
    album: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
};

const PurchasedDigitalDownloadCartItem = ({ item, onRemove }) => {
  return (
    <div className="checkout-cart-item checkout-digital-download-cart-item">
      <div className="checkout-cart-item-content">
        <div className="checkout-cart-item-figure">
          <CartItemPhotoPreview photo={item.photo}>
            <span className="checkout-cart-item-photo-icon">
              <SaveIcon color="#0d84fe" size={18} />
            </span>
          </CartItemPhotoPreview>
        </div>

        <div className="checkout-cart-item-info">
          <span className="checkout-cart-item-title">
            Digital Download
            <button
              className="checkout-cart-item-btn-remove"
              onClick={() => onRemove(item.id)}
            >
              <TrashIcon color="#fe5851" size={18} />
            </button>
          </span>

          <Badge className="text-extra-bold" badgeStyle="yellow">
            PAID
          </Badge>
          <CartItemVendor cartItem={item} />

          <div className="checkout-cart-item-description">
            Hi&ndash;Res digital download for this photo.
          </div>
        </div>
      </div>
    </div>
  );
};

PurchasedDigitalDownloadCartItem.propTypes = propTypes;

export default PurchasedDigitalDownloadCartItem;
